customElements.define('component-menu-item-ftr', class MenuItemFtr extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const template = document.getElementById('js-menu-item-template');
    this.appendChild(template.content.cloneNode(true));

    // Properties
    this.titleYes = this.getAttribute('title') || '';
    this.titleNot = this.getAttribute('title-not') || '';
    this.urlNot = this.getAttribute('url-not') || '#';
    this.showActive = this.getAttribute('show-active') === 'true' || false;

    // DOM elements
    this.menuListItem = this.querySelector('.menu-item');
    this.menuLink = this.querySelector('.menu-link');

    // Init
    this.ftrResultsUrl = localStorage.getItem('_tl_ftr_results_url');
    this.title = this.ftrResultsUrl ? this.titleYes : this.titleNot;
    this.url = this.ftrResultsUrl ? this.ftrResultsUrl : this.urlNot;

    this.key = this.normalizeKey(this.title);
    this.menuListItem.setAttribute('data-attribute', this.key);
    this.menuLink.href = this.url;
    this.menuLink.innerHTML = this.title;
    this.menuLink.classList.add('ftr');
    this.menuLink.classList.remove('menu-link-hover');
    this.menuLink.addEventListener('click', () => {
      this.trackGTM(this.title, this.url, 0);
    });

    if (this.showActive) {
      if (window.location.href.includes(this.urlNot)) {
        this.menuLink.classList.add('active-menu');
      }
    }

    // No submenu
    this.menuLink.classList.add('nosub');
  }

  normalizeKey(key) {
    return key.replace(/\W/g, '-').toLowerCase();
  }
  trackGTM(title, url, position) {
    window.sendGTMData && window.sendGTMData({
      event: 'menu_nav_click',
      source: 'menu_nav',
      nav_bar_section_text: title,
      nav_bar_section_position: position,
      nav_bar_section_url: url
    });
  }
});
